// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__xFMZ_","iconHover":"styles_iconHover__1srgi","SocialMediaButton":"styles_SocialMediaButton__1tNtn"};